// Remembers the last authenticated view so a cold app launch (the PWA's
// start_url '/', the macOS wrapper, a bare app.linkflare.io tab) continues
// where the user left off instead of always opening All Bookmarks.
//
// The restore MUST happen in the '/' redirect, not after Clerk loads: the
// router's afterEach persists every authenticated route, so the cold-start
// navigation itself writes '/bookmarks' and overwrites the saved view before
// any async check can read it. The redirect runs before afterEach.

export const LAST_ROUTE_KEY = 'linkflare_last_route'

/** router.afterEach hook: saves authenticated routes, skips one-shot ones (/share, /invitations/…). */
export function persistLastRoute(to) {
  if (!to.meta.requiresAuth || to.meta.noLastRoutePersist) return
  try {
    localStorage.setItem(LAST_ROUTE_KEY, to.fullPath)
  } catch (e) {
    // localStorage not available (e.g. private browsing with strict settings)
  }
}

/** The saved route if it still resolves to a restorable authenticated route, else null. */
export function getSavedLastRoute(router) {
  let saved = null
  try { saved = localStorage.getItem(LAST_ROUTE_KEY) } catch (e) { }
  if (!saved) return null
  try {
    const resolved = router.resolve(saved)
    if (resolved.meta.requiresAuth && !resolved.meta.noLastRoutePersist) {
      return saved
    }
  } catch (e) { }
  return null
}

/**
 * Redirect target for '/'. Only a bare launch restores: '/' with a query or
 * hash (?lang=, ?lf_from=, …) keeps the old '/bookmarks' landing, and the
 * router carries those params over as before.
 */
export function resolveLaunchRoute(to, router) {
  const isBareLaunch = Object.keys(to.query).length === 0 && !to.hash
  return (isBareLaunch && getSavedLastRoute(router)) || '/bookmarks'
}

/**
 * Where a share-target launch (/share, /save) settles once its params are
 * consumed: the Bookmarks view the user last had (e.g. the Inbox) rather than
 * All Bookmarks, which afterEach would otherwise save as the new last view.
 * Any other last view falls back to '/bookmarks', where the add dialog lives.
 */
export function shareTargetLandingRoute(router) {
  const saved = getSavedLastRoute(router)
  return saved && router.resolve(saved).path === '/bookmarks' ? saved : '/bookmarks'
}
